module.exports = __webpack_public_path__ + "media/landing/ginnel-logo-9400350c.png";